import React from 'react';
import { get, chain } from 'lodash';
import { pluralize } from 'services/helpers/formatters';
import formatPrice from 'services/helpers/formatPrice';

const LabelAmount = (props) => {
  const { record } = props;

  const labelPrice = get(record, 'details.labelPrice');
  const currency = Object.keys(get(record, 'amounts') ?? {}).find((key) => key !== 'LABEL');

  return <span>-{formatPrice(labelPrice, { currency })}</span>;
};

const AmountsField = (props) => {
  const { record, source } = props;

  const handleAmount = (value, currency) => {
    if (currency === 'LABEL') {
      return pluralize(value, 'label');
    }

    return value.toLocaleString('en-US', { style: 'currency', currency });
  };

  const amountsObject: { [key: string]: number } = get(record, source);

  if (!amountsObject) {
    return <span>-</span>;
  }

  const amountsValue = chain(amountsObject)
    .map((value, currency) => ({ value, currency }))
    .sortBy(['currency.length', 'currency'])
    .map(({ value, currency }) => handleAmount(value, currency))
    .value();

  if (record?.type === 'PURCHASE' && !Object.keys(amountsObject ?? {}).includes('LABEL')) {
    return <LabelAmount record={record} />;
  }

  return <span>{amountsValue.join(', ')}</span>;
};

export default AmountsField;
